export const NO_PERMISSION = 'NoPermissions';
export const NO_LICENSE = 'NoLicense';
export const ACCESS_DENIED = 'AccessDenied';
export const NO_USER = 'UserNotFound';
export const NO_SSO_PROFILE_ID = 'MissingSSOProfileID';
export const NO_CORP_ACC_NUMBER = 'MissingCorporateAccountNumber';
